export { default } from "./StrainListV2";
